module.exports = ".conts {\n  float: left; }\n\n.labl {\n  font-size: 20px; }\n\n.val {\n  font-size: 24px; }\n\n.container.se-cont {\n  margin: 5% 15%;\n  padding: 4%;\n  border: 1px solid #e4e0e0;\n  border-radius: 4px; }\n\n.save-summ {\n  padding: 2% 5%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/savings-estimate/savings-estimate.component.scss
// module id = ./src/app/savings-estimate/savings-estimate.component.scss
// module chunks = main